import { FieldNames } from 'Constants/FieldNames'
import { ShortDataModel } from 'Models'
import { Access } from 'Constants/FunctionAliases'
import { PurchaseTypesByRole } from 'Pages/ibro'

export enum PurchaseType {
	FZ44 = 'fz_44', // 44-FZ
	FZ223 = 'fz_223', // 223-FZ
	PP615 = 'pp_615', // 615-PP
}

export enum LegalAuthorityType {
	NO = 'No',
	FORPUBCITIZEN = 'ForPubCitizen',
	RELATFORPUBCITIZEN = 'RelatForPubCitizen',
	OFFICPUBINTORG = 'OfficPubIntOrg',
	PUBOFFICRUS = 'PubOfficRus',
	DIRECTBANKRUS = 'DirectBankRus',
	PUBOFFICRUSPRESIDENT = 'PubOfficRusPresident',
	PUBOFFICBANKRUS = 'PubOfficBankRus',
	GOVCORPRUS = 'GovCorpRus',
}

export enum TaxReasonType {
	NO = 'А',
	NO_FL = 'Б',
	OTHER = 'В',
}
export const TaxReasonTypeTranslate = {
	[TaxReasonType.NO]: 'Юрисдикция не присваивает ИНН',
	[TaxReasonType.NO_FL]: 'Юрисдикция не присвоила ИНН физическому лицу',
}

export enum ReputationType {
	NONE = '',
	REPUTATIONSBER = 'ReputationSber',
	REPUTATIONANOTHER = 'ReputationAnother',
}

export const PurchaseTypeTranslate = {
	[PurchaseType.FZ44]: '44-ФЗ',
	[PurchaseType.FZ223]: '223-ФЗ',
	[PurchaseType.PP615]: 'ПП РФ №615',
}

export enum BankGuaranteeKinds {
	GOVERNMENT = 'government',
	COMMERCIAL = 'commercial',
}

export enum BankGuaranteeTypes {
	GOV_PUBLIC = 'gov_public',
	GOV_PRIVATE = 'gov_private',
	GOV_SINGLE_SUPPLIER = 'gov_single_supplier',
	COMMERCIAL = 'commercial',
	COMMERCIAL_DIRECT = 'commercial_direct',
	SBBOL = 'sbbol',
}

export enum BenefInfoType {
	UNASSIGNED = 'BenefDirector',
	OTHER = 'BenefAnother',
}
export const BenefInfoTypeTranslate = {
	[BenefInfoType.UNASSIGNED]:
		'Бенефициарным владельцем является единоличный исполнительный орган организации',
	[BenefInfoType.OTHER]:
		'Бенефициарным(ыми) владельцем(ами) является(ются) иное(ые) физическое(ие) лицо(а)',
}

export enum ConditionsType {
	EQ = 'eq',
}

export enum FixedCommissionType {
	FIXED = '1',
	NO_FIXED = '0',
}

export enum GuaranteeTextType {
	STANDARD = 'standard',
	STANDARD_PP = 'standard_pp',
	CUSTOM = 'custom',
}

export const GuaranteeTextTypeFullInfo = {
	[GuaranteeTextType.STANDARD]: {
		title: 'По форме ПАО Сбербанк',
	},
	[GuaranteeTextType.STANDARD_PP]: {
		title: 'По форме Постановления Правительства РФ от 09.08.2022 №1397',
	},
	[GuaranteeTextType.CUSTOM]: {
		title: 'Изменения в стандартном тексте',
	},
}

export const guaranteeTextTypeWithField = {
	[GuaranteeTextType.STANDARD]: FieldNames.GUARANTEETEMPLATE,
	[GuaranteeTextType.STANDARD_PP]: FieldNames.GUARANTEETEMPLATEPP,
}

export enum GuaranteeMediumType {
	ELECTRONIC = '0',
	PAPER = '1',
}
export const GuaranteeMediumTypeTranslate = {
	[GuaranteeMediumType.ELECTRONIC]: 'Электронно',
	[GuaranteeMediumType.PAPER]: 'На бумаге',
}

export enum GuaranteeType {
	REQUEST = 'Request',
	EXECUTION = 'Execution',
	WARRANTY = 'Warranty',
	PROCURINGREFUND = 'ProcuringRefund',
}
export const GuaranteeTypeTranslate = {
	[GuaranteeType.REQUEST]: 'Обеспечение заявки',
	[GuaranteeType.EXECUTION]: 'Исполнение контракта',
	[GuaranteeType.WARRANTY]: 'Гарантийные обязательства',
	[GuaranteeType.PROCURINGREFUND]: 'Возврат аванса',
}
export const relationGuaranteeTypeAmount = {
	[GuaranteeType.REQUEST]: FieldNames.CUSTOMER_APPLICATION_GUARANTEE,
	[GuaranteeType.EXECUTION]: FieldNames.CUSTOMER_CONTRACT_GUARANTEE,
	[GuaranteeType.WARRANTY]: FieldNames.CUSTOMER_WARRANTY_GUARANTEE,
}

export enum TYPE_ORGANIZATION {
	IP = 'ip',
	OOO = 'ooo',
}

export const BgClientInfoTranslate = {
	[TYPE_ORGANIZATION.OOO]: 'Сведения о заявителе',
	[TYPE_ORGANIZATION.IP]: 'Сведения об ИП',
}

export const GUARANTEE_TYPE_ITEMS: ShortDataModel[] = [
	{
		id: 'Request fz_44',
		name: 'Обеспечение заявки по 44-ФЗ',
	},
	{
		id: 'Execution fz_44',
		name: 'Исполнение контракта по 44-ФЗ',
	},
	{
		id: 'Warranty fz_44',
		name: 'Гарантийные обязательства по 44-ФЗ',
	},
	{
		id: 'Request fz_223',
		name: 'Обеспечение заявки по 223-ФЗ',
	},
	{
		id: 'Execution fz_223',
		name: 'Исполнение контракта по 223-ФЗ',
	},
	{
		id: 'Execution pp_615',
		name: 'Исполнение контракта по ПП РФ №615',
	},
]

export const guaranteeTypesByPtype = {
	[BankGuaranteeTypes.GOV_PUBLIC]: {
		[PurchaseType.FZ44]: [GuaranteeType.REQUEST, GuaranteeType.EXECUTION, GuaranteeType.WARRANTY],
		[PurchaseType.FZ223]: [
			GuaranteeType.REQUEST,
			GuaranteeType.EXECUTION,
			GuaranteeType.WARRANTY,
			GuaranteeType.PROCURINGREFUND,
		],
		[PurchaseType.PP615]: [GuaranteeType.EXECUTION],
	},
	[BankGuaranteeTypes.GOV_PRIVATE]: {
		[PurchaseType.FZ44]: [GuaranteeType.REQUEST, GuaranteeType.EXECUTION, GuaranteeType.WARRANTY],
		[PurchaseType.FZ223]: [GuaranteeType.REQUEST, GuaranteeType.EXECUTION],
	},
	[BankGuaranteeTypes.GOV_SINGLE_SUPPLIER]: {
		[PurchaseType.FZ44]: [GuaranteeType.EXECUTION, GuaranteeType.WARRANTY],
		[PurchaseType.FZ223]: [
			GuaranteeType.EXECUTION,
			GuaranteeType.WARRANTY,
			GuaranteeType.PROCURINGREFUND,
		],
	},
	[BankGuaranteeTypes.COMMERCIAL_DIRECT]: {
		[PurchaseType.FZ44]: [
			GuaranteeType.EXECUTION,
			GuaranteeType.PROCURINGREFUND,
			GuaranteeType.WARRANTY,
		],
	},
}

export const PurchaseTypeDescription = {
	[BankGuaranteeTypes.GOV_PRIVATE]: {
		[PurchaseType.FZ44]: 'Закрытые закупки на специализированных ЭТП',
		[PurchaseType.FZ223]: 'Закупки размещенные на специализированных ЭТП',
	},
}

export const guaranteeTypesWithFunction = {
	[BankGuaranteeTypes.COMMERCIAL]: Access.broker.create_commercial,
	[BankGuaranteeTypes.GOV_PRIVATE]: Access.broker.bg_gov_private,
	[BankGuaranteeTypes.GOV_SINGLE_SUPPLIER]: Access.broker.bg_gov_single_supplier,
	[BankGuaranteeTypes.COMMERCIAL_DIRECT]: Access.broker.bg_commercial_direct_create,
	[BankGuaranteeTypes.SBBOL]: Access.broker.bg_sbbol_create,
}

export const purchaseTypesByRoles: PurchaseTypesByRole = {}

export const purchaseCodeLengthByType = {
	[PurchaseType.FZ44]: 19,
	[PurchaseType.FZ223]: 11,
}

export enum DistributionType {
	CURRENT_PARTNER = 'current_partner',
	ANOTHER_PARTNER = 'another_partner',
}

export const BgGovTypes = [
	BankGuaranteeTypes.GOV_PRIVATE,
	BankGuaranteeTypes.GOV_PUBLIC,
	BankGuaranteeTypes.GOV_SINGLE_SUPPLIER,
]
